// Danh sách tỉnh thành Việt Nam
export const VIETNAM_PROVINCES = [
    'Tuyên Quang',
    'Lào Cai',
    'Thái Nguyên',
    'Phú Thọ',
    'Bắc Ninh',
    'Hưng Yên',
    'Hải Phòng',
    'Ninh Bình',
    'Quảng Trị',
    'Đà Nẵng',
    'Quảng Ngãi',
    'Gia Lai',
    'Khánh Hoà',
    'Lâm Đồng',
    'Đắk Lắk',
    'Hồ Chí Minh',
    'Đồng Nai',
    'Tây Ninh',
    'Cần Thơ',
    'Vĩnh Long',
    'Đồng Tháp',
    'Cà Mau',
    'An Giang',
    'Hà Nội',
    'Huế',
    'Lai Châu',
    'Điện Biên',
    'Sơn La',
    'Lạng Sơn',
    'Quảng Ninh',
    'Thanh Hoá',
    'Nghệ An',
    'Hà Tĩnh',
    'Cao Bằng'
];


export const getProvinceOptions = () => [
    { label: 'Tất cả tỉnh thành', value: '' },
    ...VIETNAM_PROVINCES.map(province => ({ label: province, value: province }))
];

export const getProvinceSelectOptions = () => 
    VIETNAM_PROVINCES.map(province => ({ label: province, value: province }));
